import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/season_cup.svg")